document.addEventListener('DOMContentLoaded', function(){

  const trigger = document.querySelector('.gllora-offer-strip');
  const drawer = document.querySelector('.gllora-offer-drawer');
  const backdrop = document.querySelector('.gllora-offer-backdrop');
  const closeBtn = document.querySelector('.gllora-close-drawer');

  if(trigger){

    trigger.addEventListener('click', function(){

      drawer.classList.add('active');
      backdrop.classList.add('active');

      document.body.style.overflow = 'hidden';

    });

  }

  function closeDrawer(){

    drawer.classList.remove('active');
    backdrop.classList.remove('active');

    document.body.style.overflow = '';

  }

  if(closeBtn){
    closeBtn.addEventListener('click', closeDrawer);
  }

  if(backdrop){
    backdrop.addEventListener('click', closeDrawer);
  }

  const tabs = document.querySelectorAll('.gllora-tab');

  tabs.forEach(tab => {

    tab.addEventListener('click', function(){

      document.querySelectorAll('.gllora-tab').forEach(item => {
        item.classList.remove('active');
      });

      document.querySelectorAll('.gllora-tab-content').forEach(item => {
        item.classList.remove('active');
      });

      tab.classList.add('active');

      document.getElementById(tab.dataset.tab).classList.add('active');

    });

  });

  const copyButtons = document.querySelectorAll('.gllora-copy-btn');

  copyButtons.forEach(button => {

    button.addEventListener('click', function(){

      navigator.clipboard.writeText(button.dataset.copy);

      button.innerText = 'Copied';

      setTimeout(() => {

        button.innerText = 'Copy code';

      }, 2000);

    });

  });

});